(function () {
  var STORAGE_KEY = 'japonija.cookie-consent.v1';

  // Suppress Shopify's native cookie banner — we use our own.
  // It is injected as a <shop-cookie-banner> custom element by Shopify's
  // privacy banner runtime. Remove instances + watch for late injection.
  function killShopifyBanner() {
    var sel = 'shop-cookie-banner, .shopify-pc__banner, #shopify-pc__banner';
    document.querySelectorAll(sel).forEach(function (el) { el.remove(); });
  }
  killShopifyBanner();
  document.addEventListener('DOMContentLoaded', killShopifyBanner);
  try {
    new MutationObserver(killShopifyBanner).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (e) { return null; }
  }

  function writeConsent(consent) {
    consent.ts = new Date().toISOString();
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(consent)); } catch (e) {}
    applyToShopify(consent);
    document.documentElement.setAttribute('data-cookie-consent', 'set');
  }

  function applyToShopify(consent) {
    if (!window.Shopify || !window.Shopify.customerPrivacy || typeof window.Shopify.customerPrivacy.setTrackingConsent !== 'function') return;
    try {
      window.Shopify.customerPrivacy.setTrackingConsent({
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        preferences: !!consent.functional,
        sale_of_data: !!consent.marketing
      }, function () {});
    } catch (e) {}
  }

  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  document.addEventListener('DOMContentLoaded', function () {
    var banner = document.querySelector('[data-cookie-banner]');
    var dialog = document.querySelector('[data-cookie-dialog]');
    if (!banner) return;

    var existing = readConsent();
    if (existing) {
      applyToShopify(existing);
    } else {
      show(banner);
    }

    function commit(consent) {
      writeConsent(consent);
      hide(banner);
      if (dialog && typeof dialog.close === 'function' && dialog.open) dialog.close();
    }

    banner.querySelectorAll('[data-cookie-accept-all]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        commit({ essential: true, analytics: true, marketing: true, functional: true });
      });
    });

    document.querySelectorAll('[data-cookie-reject]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        commit({ essential: true, analytics: false, marketing: false, functional: false });
      });
    });

    banner.querySelectorAll('[data-cookie-settings-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!dialog) return;
        var current = readConsent() || { analytics: false, marketing: false, functional: false };
        dialog.querySelectorAll('[data-cookie-toggle]').forEach(function (input) {
          var key = input.getAttribute('data-cookie-toggle');
          input.checked = !!current[key];
        });
        if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
      });
    });

    if (dialog) {
      dialog.querySelectorAll('[data-cookie-settings-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
        });
      });

      dialog.querySelectorAll('[data-cookie-save]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var consent = { essential: true, analytics: false, marketing: false, functional: false };
          dialog.querySelectorAll('[data-cookie-toggle]').forEach(function (input) {
            consent[input.getAttribute('data-cookie-toggle')] = !!input.checked;
          });
          commit(consent);
        });
      });
    }
  });
})();
